import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Logo } from "@/components/Logo";

const COLS = [
  ["Assistenza", [["/contatti", "Contatti"], ["/assistenza", "Assistenza clienti"], ["/ordine", "Il mio ordine"], ["/pagina/spedizioni", "Spedizioni"], ["/pagina/resi-e-rimborsi", "Resi e rimborsi"], ["/pagina/garanzia", "Garanzia"]]],
  ["Informazioni", [["/pagina/chi-siamo", "Chi siamo"], ["/pagina/cloud-free", "Dispositivi CLOUD FREE"], ["/pagina/termini-e-condizioni", "Termini e condizioni"], ["/pagina/privacy", "Privacy Policy"], ["/pagina/cookie", "Cookie Policy"], ["/pagina/note-legali", "Note legali"]]],
];

export const Footer = () => (
  <footer className="mt-24 bg-[#0A0B0E] text-white" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <Logo tone="dark" />
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">Smartphone nuovi, usati Premium, ricondizionati, dispositivi CLOUD FREE e prodotti tecnologici.</p>
        <a href="tel:+393791192613" data-testid="footer-phone" className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-semibold transition-colors hover:border-[#0066FF] hover:text-[#4D94FF]">
          <Phone className="h-4 w-4" /> +39 379 119 2613
        </a>
      </div>
      {COLS.map(([title, links]) => (
        <div key={title}>
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-[#4D94FF]">{title}</p>
          <ul className="mt-5 space-y-3">
            {links.map(([to, label]) => (
              <li key={to}><Link to={to} data-testid={`footer-link-${to.split("/").pop()}`} className="text-sm text-slate-300 transition-colors hover:text-white">{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-4 py-6 text-xs leading-relaxed text-slate-400 sm:px-6" data-testid="footer-company">
        © {new Date().getFullYear()} LEONTECH · www.leontechshop.it — LEONTECH è il nome commerciale dell'impresa individuale ONLINE SHOP 2.0 DI ETTORE PUDDU, P. IVA 03329290732 · Via Atenisio Carducci Cataldantonio 10, 74121 Taranto (TA) · REA TA-208699
      </div>
    </div>
  </footer>
);
